import createInstance from '../http';
import config from '@/const/config';
const { request } = createInstance(config.goodsBaseUrl);
// http://mock.qa.91jkys.com/project/212?moduleId=1012&interfaseId=7891
export default {
  getGoodsInfo: params => request.post(`/api/share-mall-gateway-goods/1.0/query_item_detail_info`, params), // 商品详情
  getGoodsList: params => request.get(`/api/share-mall-gateway-goods/1.0/search_item_aspect`, { params }), // 商品列表(搜索商品)
  getSearchSortType: params => request.get(`/api/share-mall-gateway-search/1.0/sort_type`, { params }), // 查询排序类型
  getActiveGoodsList: params => request.get(`/api/share-mall-gateway-goods/1.0/index_activity_item`, { params }), // 获取活动商品
  getCategoryGoodsList: params => request.get(`/api/share-mall-gateway-goods/1.0/index_prefecture_item`, { params }), //  获取专区商品
  getSearchAssociationWord: params =>
    request.get(`/api/share-mall-gateway-search/1.0/search_association_word`, { params }), // 搜索联想词
  getGoodsCategory: params => request.post(`/api/share-mall-gateway-goods/1.0/query_display_category`, params), // 全部分类查询接口
  queryItemByCoupon: params =>
    request.get(`/api/share-mall-gateway-goods/1.0/query_item_bear_page_by_coupon`, { params }), // 优惠券使用商品承载页
  goodsStockOutAlert: params => request.post(`/api/share-mall-gateway-goods/1.0/goods_stock_out_alert`, params), // 商品补货提醒
};
